import React from 'react';
import { Search } from 'lucide-react';

/**
 * Reusable admin search input styled exactly like the Enquiries tab search
 * bar. Client-side filtering is left to the consumer via onChange + useMemo.
 */
const AdminSearch = ({ value, onChange, placeholder = 'Search…', testId, className = '', hint }) => (
  <div className={`relative ${className}`}>
    <Search size={14} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
    <input
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
      className="w-full pl-9 pr-16 py-2.5 border border-gray-200 rounded-md text-sm focus:border-[#0d64a8] outline-none"
      data-testid={testId || 'admin-search'}
    />
    {value && (
      <button
        onClick={() => onChange('')}
        className="absolute right-3 top-1/2 -translate-y-1/2 text-xs text-gray-400 hover:text-gray-700"
        type="button"
      >
        Clear
      </button>
    )}
    {hint && !value && (
      <span className="absolute right-3 top-1/2 -translate-y-1/2 text-[10px] text-gray-300">
        {hint}
      </span>
    )}
  </div>
);

export default AdminSearch;
